/**
 * Where the provider lands after a re-send that saved a new copy of a chart document (ENG-3764 D3). The copy exists and
 * the original was retired the moment it was saved, so the page moves to the copy whether or not the Task wait that
 * follows succeeds; staying on the retired original would let the provider send it again.
 */
export function resentChartDocumentHref(clientId: string | undefined, resendAsNew: boolean, savedId: string | undefined): string | undefined {
  return clientId && resendAsNew && savedId ? `/dashboard/clients/${clientId}/chart-document/${savedId}` : undefined;
}
